import { Outlet, useMatch } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { ROUTE_PAYMENT } from '@/constants/routes';
import { loadStripe } from '@stripe/stripe-js';
import envService from '@/services/env.service';
import { isNewMembershipsEnabled } from '@/services/new-memberships.service';
import { NewMembershipsClosedPage } from '../new-memberships-closed/NewMembershipsClosedPage';
import { PaymentPageV2 } from './PaymentPageV2';

// Singleton Stripe instance for child routes that only need useStripe()
let verifyStripePromise: ReturnType<typeof loadStripe> | null = null;
function getVerifyStripePromise() {
  if (!verifyStripePromise) {
    verifyStripePromise = loadStripe(envService.getEnv().VITE_STRIPE_PUBLISHABLE_KEY);
  }
  return verifyStripePromise;
}

export function PPRAPaymentPageWrapper() {
  const isExactPayment = useMatch(ROUTE_PAYMENT);

  if (isExactPayment) {
    if (!isNewMembershipsEnabled()) {
      return <NewMembershipsClosedPage />;
    }

    return <PaymentPageV2 />;
  }

  // Child routes (e.g. verify-payment) need Stripe Elements for useStripe()
  return (
    <Elements stripe={getVerifyStripePromise()}>
      <Outlet />
    </Elements>
  );
}

export default PPRAPaymentPageWrapper;
